import React from 'react';
import { Link } from 'gatsby';
import './button.scss';

var Button = function Button(_ref) {
  var size = _ref.size,
      type = _ref.type,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      inverse = _ref.inverse,
      children = _ref.children,
      to = _ref.to,
      className = _ref.className;

  if (to) {
    return /*#__PURE__*/React.createElement(Link, {
      to: to,
      className: "button button--" + (size || 'default') + " " + (inverse && 'button--inverse') + " " + (className && className)
    }, children);
  }

  return /*#__PURE__*/React.createElement("button", {
    className: "button button--" + (size || 'default') + "\n  " + (inverse && 'button--inverse') + " " + (className && className),
    type: type ? type : 'button',
    onClick: onClick,
    disabled: disabled
  }, children);
};

export default Button;